import React, { useEffect, useState } from "react";
import { ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { api } from "@/lib/api";

export function PatientPicker({ value, onPick, testid, disabled }) {
  const [open, setOpen] = useState(false);
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/patients").then((r) => setList(r.data)).catch(() => setList([])); }, []);
  const cur = list.find((p) => p.id === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" disabled={disabled} className="inp flex items-center justify-between text-left disabled:opacity-60" data-testid={testid}>
          <span className={cur ? "font-medium" : "text-[var(--muted-ink)]"}>{cur ? cur.patient_id : "Search Patient ID…"}</span><ChevronsUpDown size={13} className="opacity-50" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-0" align="start">
        <Command>
          <CommandInput placeholder="Search Patient ID…" data-testid={`${testid}-search`} />
          <CommandList>
            <CommandEmpty>No patients you can access</CommandEmpty>
            <CommandGroup>
              {list.map((p) => (
                <CommandItem key={p.id} value={p.patient_id} onSelect={() => { setOpen(false); onPick(p); }} data-testid={`${testid}-option-${p.patient_id}`}>
                  {p.patient_id}<span className="ml-auto text-[11px] text-[var(--muted-ink)]">{p.medication || ""}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
